<template>
		<section class="content">
			<input id="origin-input" class="controls" type="text"
			       placeholder="Enter an origin location" v-model="origin">

			<input id="destination-input" class="controls" type="text"
			       placeholder="Enter a destination location" v-model="destination">

			<input id="budget-input" class="controls" type="text"
			       placeholder="Enter budget" v-model="budget" v-on:keypress="isNumber(evt)">

			<button v-on:click="callDriver" type="button" class="controls" id="call-button">Call Driver Now!</button>

			<div id="map">
			</div>
		</section>
</template>
<script>
import $ from 'jquery'
export default {
	data: function() {
		return {
			origin_input: null,
			destination_input: null,
			origin_lat : 16.860408,
			origin_lng : 96.194906,
			destination_lat : 16.960408,
			destination_lng : 96.194906,
		}
	},
	mounted: function() {
		var self = this
    var origin_place_id = null;
    var destination_place_id = null;
    var travel_mode = 'DRIVING';
    var map = new google.maps.Map(document.getElementById('map'), {
        mapTypeControl: false,
        center: {lat: 16.860408, lng: 96.194906},
        zoom: 13
    });
    var directionsService = new google.maps.DirectionsService;
    var directionsDisplay = new google.maps.DirectionsRenderer({
        draggable: true,
//            suppressMarkers: true,
	        map: map
	    });
	    directionsDisplay.setMap(map);
	    var origin_input = document.getElementById('origin-input');
	    var destination_input = document.getElementById('destination-input');
	    var budget_input = document.getElementById('budget-input');
	    var call_input = document.getElementById('call-button');

			map.controls[google.maps.ControlPosition.LEFT_TOP].push(origin_input);
			map.controls[google.maps.ControlPosition.LEFT_TOP].push(destination_input);
			map.controls[google.maps.ControlPosition.LEFT_TOP].push(budget_input);
			map.controls[google.maps.ControlPosition.LEFT_TOP].push(call_input);
			var options = {
				componentRestrictions: {country: 'MM'}
			};
			var origin_autocomplete = new google.maps.places.Autocomplete(origin_input,options);
			origin_autocomplete.bindTo('bounds', map);
			var destination_autocomplete =
			new google.maps.places.Autocomplete(destination_input,options);
			destination_autocomplete.bindTo('bounds', map);

			function expandViewportToFitPlace(map, place) {
		    if (place.geometry.viewport) {
		      map.fitBounds(place.geometry.viewport);
		    } else {
		      map.setCenter(place.geometry.location);
		      map.setZoom(17);
		    }
			}

		origin_autocomplete.addListener('place_changed', function() {
	    var place = origin_autocomplete.getPlace();
	    if (!place.geometry) {
	        window.alert("Autocomplete's returned place contains no geometry");
	        return;
	    }
	     self.origin_lat = place.geometry.location.lat();
	     self.origin_lng = place.geometry.location.lng();

	    expandViewportToFitPlace(map, place);

	    // If the place has a geometry, store its place ID and route if we have
	    // the other place ID
	    origin_place_id = place.place_id;
	    route(origin_place_id, destination_place_id, travel_mode,
	        directionsService, directionsDisplay,map);
		});

		destination_autocomplete.addListener('place_changed', function() {
	    var place = destination_autocomplete.getPlace();
	    if (!place.geometry) {
	        window.alert("Autocomplete's returned place contains no geometry");
	        return;
	    }
	     self.destination_lat = place.geometry.location.lat();
	     self.destination_lng = place.geometry.location.lng();

	    expandViewportToFitPlace(map, place);

	    // If the place has a geometry, store its place ID and route if we have
	    // the other place ID
	    destination_place_id = place.place_id;
	    route(origin_place_id, destination_place_id, travel_mode,
	        directionsService, directionsDisplay,map);
		});
		directionsDisplay.addListener('directions_changed', function() {
		  computeTotalDistance(directionsDisplay.getDirections());
		});
		function computeTotalDistance(result) {
			var origin_input = document.getElementById('origin-input');
			var destination_input = document.getElementById('destination-input');
			var myroute = result.routes[0];
			origin_input.value = myroute.legs[0].start_address;
			destination_input.value = myroute.legs[0].end_address;
			self.origin_input = myroute.legs[0].start_address;
			self.destination_input = myroute.legs[0].end_address;
		}
		function route(origin_place_id, destination_place_id, travel_mode,
		           directionsService, directionsDisplay,map) {
			if (!origin_place_id || !destination_place_id) {
			    return;
			}
			directionsService.route({
			    origin: {'placeId': origin_place_id},
			    destination: {'placeId': destination_place_id},
			    travelMode: travel_mode
			}, function(response, status) {
			    if (status === 'OK') {
			        directionsDisplay.setDirections(response);
			    } else {
			        window.alert('Directions request failed due to ' + status);
			    }
			});
		}
  },
  methods: {
    callDriver: function () {
      var self = this;
      const state = this.$store.state
      var sender = self.$route.params.sender
      var origin_input = self.origin_input;
      var destination_input =self.destination_input;
        var budget_input =self.budget;
        if(origin_input == '' || origin_input == undefined ){
        alert('Please fill Origin');return false;
        }else if(destination_input == '' || destination_input == undefined){
        alert('Please fill Destination');return false;
        }else if(budget_input == '' || budget_input == undefined){
        alert('Please fill budget');return false;
        }else {
            $.ajax({
                url: state.serverURI + "api/a/admin-trip-request",
                type:"POST",
                data:{
                    'origin_lat':self.origin_lat,
                    'origin_lng':self.origin_lng,
                    'destination_lat':self.destination_lat,
                    'destination_lng':self.destination_lng,
                    'origin_input':origin_input,
                    'destination_input':destination_input,
                    'budget_input':budget_input,
                    'sender' : sender
                },
                dataType:"json",
                complete : function(xhr,status){

                }
            });
        }
    },
    isNumber : function (evt) {
	    evt = (evt) ? evt : window.event;
	    var charCode = (evt.which) ? evt.which : evt.keyCode;
	    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
	      evt.preventDefault();;
	    } else {
	      return true;
	    }
  }
  },
}
</script>

<!-- style code -->
<style>
#map {
  min-height: 500px;
}
.controls {
  margin-top: 10px;
  border: 1px solid transparent;
  border-radius: 2px 0 0 2px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  height: 32px;
  outline: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

#origin-input,
#budget-input,
#destination-input {
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin-left: 10px;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 95%;
}
#call-button{
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin-left: 10px;
  padding: 0 11px 0 13px;
  color : red;
  width: 150px;
}

#origin-input:focus,
#budget-input:focus,
#destination-input:focus {
  border-color: #4d90fe;
}

#mode-selector {
  color: #fff;
  background-color: #4d90fe;
  margin-left: 12px;
  padding: 5px 11px 0px 11px;
}

#mode-selector label {
  font-family: Roboto;
  font-size: 13px;
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// TripRequest.vue?3eda609b